import { ArrowRight, Check, LockKeyhole } from "lucide-react";
import { Link } from "react-router-dom";
import { heroBadges } from "../data/homePageContent";
import { HeroIntakeCard } from "./HeroIntakeCard";

export function Hero() {
  return (
    <section className="hero" id="top">
      <div className="site-shell hero__grid">
        <div className="hero__copy reveal">
          <div className="eyebrow">
            <span aria-hidden="true" />
            California individual tax &middot; IRS-registered preparer
          </div>
          <h1>
            Your California tax return, done right.
            <br />
            <span>Simple returns in as little as 24 hours.</span>
          </h1>
          <p className="hero__lede">
            Answer one question at a time and upload your documents in minutes. An
            IRS-registered preparer reviews every line and e-files. Simple returns are typically
            ready in 24 hours &mdash; we tell you up front if yours will take longer.
          </p>
          <div className="hero__actions">
            <Link className="button button--primary" to="/portal">
              <span>Start Your Return</span>
              <ArrowRight aria-hidden="true" size={17} strokeWidth={2.2} />
            </Link>
            <a className="button button--secondary" href="#contact">
              Contact Us
            </a>
          </div>
          <div className="hero__badges">
            {heroBadges.map((badge, index) => (
              <span key={badge}>
                {index === 0 ? (
                  <LockKeyhole aria-hidden="true" size={14} strokeWidth={2.2} />
                ) : (
                  <Check aria-hidden="true" size={14} strokeWidth={2.4} />
                )}
                {badge}
              </span>
            ))}
          </div>
        </div>
        <div className="hero__visual reveal reveal--delay">
          <HeroIntakeCard />
        </div>
      </div>
    </section>
  );
}
